import { AppModal } from '@Common/AppModal';
import { Spinner } from '@Common/Spinner';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Elements } from '@stripe/react-stripe-js';
import { stripeOptions } from 'appConstants';
import { SetStateType } from 'commonTypes';
import { FormattedMessage } from 'react-intl';
import { useConfigureStripe } from 'store/subscription/actions';

import { StripeAdditionalForm } from '../UI/StripeAdditionalForm';

interface AddPaymentMethodProps {
  open: boolean;
  setOpen: SetStateType<boolean>;
}

export const AddPaymentMethod = ({ open, setOpen }: AddPaymentMethodProps) => {
  const { data: stripePromise, isPending } = useConfigureStripe();

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <AppModal open={open} size="max-w-xl">
      <div className="flex w-full items-center justify-between mb-3">
        <h1>
          <FormattedMessage id="addPayment" />
        </h1>
        <XMarkIcon
          onClick={closeModal}
          className="h-6 w-6 cursor-pointer text-gray-500 md:hover:text-gray-700"
        />
      </div>
      {isPending || !stripePromise ? (
        <Spinner color="bg-primary" />
      ) : (
        <Elements stripe={stripePromise} options={stripeOptions}>
          <StripeAdditionalForm closeModal={closeModal} />
        </Elements>
      )}
    </AppModal>
  );
};
